import { render, staticRenderFns } from "./XmTitleDialog.vue?vue&type=template&id=b7858f86&scoped=true"
import script from "./XmTitleDialog.vue?vue&type=script&lang=js"
export * from "./XmTitleDialog.vue?vue&type=script&lang=js"
import style0 from "./XmTitleDialog.vue?vue&type=style&index=0&id=b7858f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7858f86",
  null
  
)

export default component.exports